import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function OpsGenieIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M11.9995 11.9698C15.3049 11.9698 17.9844 9.29025 17.9844 5.98489C17.9844 2.67952 15.3049 0 11.9995 0C8.69417 0 6.01465 2.67952 6.01465 5.98489C6.01465 9.29025 8.69417 11.9698 11.9995 11.9698Z"
        fill="url(#paint0_linear_10640_68266)"
      />
      <path
        d="M11.4896 23.839C7.58098 21.3456 4.33027 17.9476 2.01245 13.9324C1.92285 13.7714 1.90337 13.5807 1.95857 13.405C2.01376 13.2293 2.13878 13.0839 2.30431 13.0031L6.83659 10.7789C7.15362 10.6243 7.53623 10.7416 7.71218 11.0473C10.0036 14.8878 13.3919 17.9548 17.441 19.8535C15.9476 21.3582 14.2939 22.6946 12.5095 23.839C12.1974 24.0338 11.8017 24.0338 11.4896 23.839Z"
        fill="url(#paint1_linear_10640_68266)"
      />
      <path
        d="M12.5094 23.839C16.4186 21.3462 19.6694 17.9481 21.9866 13.9324C22.0765 13.7719 22.0964 13.5815 22.0419 13.4058C21.9873 13.2301 21.8631 13.0846 21.6981 13.0031L17.1625 10.7789C16.8455 10.6243 16.4628 10.7416 16.2869 11.0473C13.996 14.8882 10.6075 17.9553 6.55811 19.8535C8.05052 21.3592 9.70433 22.6957 11.4896 23.839C11.8016 24.0338 12.1974 24.0338 12.5094 23.839Z"
        fill="#2684FF"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10640_68266"
          x1="604.503"
          y1="198.937"
          x2="604.503"
          y2="1427.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2684FF" />
          <stop offset="0.82" stopColor="#0052CC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10640_68266"
          x1="640.758"
          y1="424.339"
          x2="962.63"
          y2="1097.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2684FF" />
          <stop offset="0.62" stopColor="#0052CC" />
        </linearGradient>
      </defs>
    </svg>
  );
};
